<div [innerHTML]="text" class="order-summary-note">
</div>
